/**
 * Short-lived in-memory cache of just-picked photo blobs.
 *
 * Bridges the gap between a form submit (when the File blob exists in React
 * state) and the attachment queue finishing its IndexedDB write — so the
 * observation's PhotoGrid can render real thumbnails immediately instead of
 * skeletons that flip to images once each blob lands on disk.
 *
 * Entries should be released as soon as the queue has persisted the blob,
 * so we don't hold large File objects in memory longer than needed.
 */
const blobs = new Map<string, Blob>()

export function stashPhotoBlob(photoId: string, blob: Blob) {
  blobs.set(photoId, blob)
}

export function getStashedPhotoBlob(photoId: string): Blob | undefined {
  return blobs.get(photoId)
}

export function hasStashedPhotoBlob(photoId: string): boolean {
  return blobs.has(photoId)
}

export function releasePhotoBlob(photoId: string) {
  blobs.delete(photoId)
}
